export const ticketStatuses = [
    { code: 0, name: "Prijavljen" },
    { code: 10, name: "U postupku" },
    { code: 20, name: "Otkazani" },
    { code: 30, name: "Završeni" },
    { code: 40, name: "Arhivirani" },
];

export const recurringTicketStatuses = [
    { code: 10, name: "U postupku" },
    { code: 20, name: "Otkazani" },
    { code: 30, name: "Završeni" },
    { code: 40, name: "Arhivirani" },
];

export const ticketRecurrences = [
    { code: 0, name: "Dnevni" },
    { code: 7, name: "Tjedni" },
    { code: 30, name: "Mjesečni" },
    { code: 365, name: "Godišnji" }
];